import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MainView from "../../../../components/MainView";
import NavHistory from "../../../../components/NavHistory";
import accessServices from "../../../../services/accessServices";
import AccessCard from "./AccessesCard";
import AccessProfileCard from "./AccessProfileCard";

import './styles.css';


export default function AdminAccessPage(props) {
    const [access, setAccess] = useState({});
    const {id} = useParams();

    async function getAccess() {
        try {
            const response = await accessServices.getAccessInfos(id);
            setAccess(response.data);
        } catch(err) {
            alert("Erro ao pegar informações do acesso.");
        }
    } 
    useEffect(() => {
        getAccess();
    }, []);

    return (
        <MainView
        adminMenu
        currentPage="accesses"
        >
            <NavHistory
            navPages={['Acessos', (access.nome ? access.nome : "")]}
            />
            <div className="access-profile-page-container">
                <AccessProfileCard
                    accessInfos={access}
                />
                <AccessCard
                    accessInfos={access}
                    onUpdate = {data => setAccess(data)}
                />
            </div>
        </MainView>
    )
}